import { Link } from 'react-router-dom';
import { useGalleries } from '../hooks';
import FooterLoginIcon from './FooterLoginIcon';

const css = `
footer {
  background: var(--dark);
  padding: 4rem 5rem 2.5rem;
}
.footer-top {
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr 1fr 0.75fr;
  gap: 3rem;
  padding-bottom: 3rem;
  border-bottom: 1px solid rgba(141,189,189,0.12);
}
.footer-brand .logo-main {
  font-family: 'Cormorant Garamond', serif;
  font-size: 1.5rem; font-weight: 400;
  color: var(--aqua-light); margin-bottom: 0.25rem;
}
.footer-brand .logo-sub {
  font-family: 'Barlow Condensed', sans-serif;
  font-size: 0.6rem; font-weight: 600;
  letter-spacing: 0.2em; text-transform: uppercase;
  color: var(--gold); margin-bottom: 1.25rem;
}
.footer-brand p {
  font-size: 0.82rem; font-weight: 300;
  line-height: 1.75; color: rgba(255,255,255,0.4);
}
.footer-col h4 {
  font-family: 'Barlow Condensed', sans-serif;
  font-size: 0.65rem; font-weight: 700;
  letter-spacing: 0.22em; text-transform: uppercase;
  color: var(--gold); margin-bottom: 1.25rem;
}
.footer-col ul { list-style: none; }
.footer-col ul li { margin-bottom: 0.6rem; }
.footer-col ul li a {
  font-size: 0.82rem; font-weight: 300;
  color: rgba(255,255,255,0.45); text-decoration: none;
  transition: color 0.2s;
}
.footer-col ul li a:hover { color: var(--aqua-light); }
.footer-social-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: 1px solid rgba(141,189,189,0.3);
  border-radius: 50%;
  color: var(--aqua-light);
  transition: color 0.2s, border-color 0.2s;
}
.footer-social-link:hover {
  color: white;
  border-color: var(--aqua-light);
}
.footer-social-link svg { width: 18px; height: 18px; }
.footer-bottom {
  display: flex; justify-content: space-between; align-items: center;
  padding-top: 2rem;
}
.footer-bottom-links {
  display: flex; align-items: center; gap: 1rem;
}
.footer-bottom p {
  font-size: 0.75rem; font-weight: 300;
  color: rgba(255,255,255,0.25); letter-spacing: 0.05em;
}
.footer-bottom a {
  color: rgba(141,189,189,0.4); text-decoration: none;
  transition: color 0.2s;
}
.footer-bottom a:hover { color: var(--aqua-light); }
@media (max-width: 900px) {
  footer { padding: 3rem 2rem 2rem; }
  .footer-top { grid-template-columns: 1fr 1fr; gap: 2rem; }
}
`;

export default function Footer() {
  const data = useGalleries();
  
  // Sort galleries alphabetically by title
  const sortedGalleries = [...data].sort((a, b) => {
    return (a.title || '').localeCompare(b.title || '');
  });

  return (
    <>
      <style>{css}</style>
      <footer>
        <div className="footer-top">
          <div className="footer-brand">
            <div className="logo-main">Arana Bros</div>
            <div className="logo-sub">Construction</div>
            <p>Renovation, structural work, and custom installation. Two brothers. Two coasts. 75+ years combined.</p>
          </div>

          <div className="footer-col">
            <h4>Services</h4>
            <ul>
              <li><Link to="/services/repairs">Repairs & Renovations</Link></li>
              <li><Link to="/services/functional-art">Custom Installations & Functional Art</Link></li>
              <li><Link to="/services/structural">Structural Work</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Gallery</h4>
            <ul>
              {sortedGalleries.map(g => (
                <li key={g.slug}>
                  <Link to={`/gallery/${g.slug}`}>
                    {g.title || g.navLabel || g.slug}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-col">
            <h4>Contact</h4>
            <ul>
              <li><Link to="/#team">Our Team</Link></li>
              <li><Link to="/#contact">Start a Project</Link></li>
              <li><a href="mailto:contact@aranabros.com">contact@aranabros.com</a></li>
              <li><Link to="/#faq">FAQ</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Social Media</h4>
            <a
              className="footer-social-link"
              href="https://www.instagram.com/arana_brothers"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Arana Brothers on Instagram"
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
                <rect x="3" y="3" width="18" height="18" rx="5" />
                <circle cx="12" cy="12" r="4" />
                <circle cx="17.4" cy="6.6" r="1" fill="currentColor" stroke="none" />
              </svg>
            </a>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} Arana Brothers Construction. All rights reserved.</p>
          <div className="footer-bottom-links">
            <p><Link to="/terms-and-privacy">Terms &amp; Privacy</Link></p>
            <p><a href="https://aranabros.com">aranabros.com</a></p>
            <FooterLoginIcon />
          </div>
        </div>
      </footer>
    </>
  );
}
